import l10n from 'diy/util/l10n';
import ModuleDragSource = require('./ModuleDragSource');
import NavDropZone = require('./NavDropZone');
import DropZone = require('../../../../common/js/dd/DropZone');
import Modul from '../../../Modul';

/**
 * Drag source for new modules (from module selector)
 */
    class BlankModuleDragSource extends ModuleDragSource {
        public moduleLabel: string;
        public moduleType: string;
        public moduleName: string;
        public sectionName: string;

        constructor(element: JQuery) {
            super(element);

            this.setModelData();
        }

        init() {
            super.init();
            this.setDraggableOptions({
                cursorAt: {top: 0, left: 15},
                cancel: diy.editor.upgradeLayer.getSelector()
            });
        }

        setModelData() {
            super.setModelData();
            let dataSourceEl = this.getDataSourceEl();
            this.moduleLabel = dataSourceEl.attr('data-moduleLabel');
            this.moduleType = dataSourceEl.attr('data-moduleType');
            this.moduleName = dataSourceEl.attr('data-moduleName');
            this.sectionName = dataSourceEl.attr('data-sectionName');
        }

        getLabel() {
            return this.moduleLabel;
        }
        getErrorMessage(error: string, dropZone: DropZone) {
            if (dropZone instanceof NavDropZone) {
                switch (error) {
                    case 'module_singleton_in_page': //nobreak
                    case 'module_singleton_in_other_pages':
                        return l10n('module.warningSingleton');
                    case 'module_too_wide':
                        return l10n('module.addToPageWarningTooWide');
                    default:
                        break;
                }
            }
            return super.getErrorMessage(error, dropZone);
        }

        doDrop(dropZone: DropZone) {
            Modul.add(Modul.getInsertParams(this), dropZone.getDestinationParams());
        }
    }

export = BlankModuleDragSource;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/dd/BlankModuleDragSource.ts
 **/